// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup_wrapper_light {
  border: 1px solid #d8d8d8;
  z-index: 999;
  background-color: white;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  margin: 5px;
}

.popup_wrapper_dark {
  border: 1px solid #272727;
  z-index: 999;
  background-color: #282c34;
  box-shadow: 0px 0px 8px rgba(255, 255, 255, 0.3);
  border-radius: 5px;
  margin: 5px;
}

.hoverStand_light {
  cursor: pointer;
  padding: 8px 6px;
  margin: 0;
  display: flex;
  align-items: center;
  font-size: 14px;
}

.hoverStand_light:hover {
  background-color: #f1f1f1;
}

.hoverStand_dark {
  cursor: pointer;
  padding: 8px 6px;
  margin: 0;
  display: flex;
  align-items: center;
  font-size: 14px;
}

.hoverStand_dark:hover {
  background-color: #0e0e0e;
}

.icon_dark {
  border: 1px solid #666;
  color: #1f2023,
}

.icon_light {
  border: 1px solid #ddd;
  color: #ddd,
}

.item_dark {
  color: #dadada;
  font-size: 14px;
}

.item_light {
  color: #1f2023;
  font-size: 14px;
}

.warning_area_dark {
  color: #aaa;
  background-color: #444;
}

.warning_area_light {
  color: gray;
  background-color: #f5f5f5;
}`, "",{"version":3,"sources":["webpack://./src/components/slides-editor/cmdMenu.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EAGvB,0CAA0C;EAK1C,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EAGzB,gDAAgD;EAKhD,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB;AACF;;AAEA;EACE,sBAAsB;EACtB;AACF;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B","sourcesContent":[".popup_wrapper_light {\n  border: 1px solid #d8d8d8;\n  z-index: 999;\n  background-color: white;\n  -webkit-box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);\n  -moz-box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);\n  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  -ms-border-radius: 5px;\n  -o-border-radius: 5px;\n  border-radius: 5px;\n  margin: 5px;\n}\n\n.popup_wrapper_dark {\n  border: 1px solid #272727;\n  z-index: 999;\n  background-color: #282c34;\n  -webkit-box-shadow: 0px 0px 8px rgba(255, 255, 255, 0.3);\n  -moz-box-shadow: 0px 0px 8px rgba(255, 255, 255, 0.3);\n  box-shadow: 0px 0px 8px rgba(255, 255, 255, 0.3);\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  -ms-border-radius: 5px;\n  -o-border-radius: 5px;\n  border-radius: 5px;\n  margin: 5px;\n}\n\n.hoverStand_light {\n  cursor: pointer;\n  padding: 8px 6px;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n}\n\n.hoverStand_light:hover {\n  background-color: #f1f1f1;\n}\n\n.hoverStand_dark {\n  cursor: pointer;\n  padding: 8px 6px;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n}\n\n.hoverStand_dark:hover {\n  background-color: #0e0e0e;\n}\n\n.icon_dark {\n  border: 1px solid #666;\n  color: #1f2023,\n}\n\n.icon_light {\n  border: 1px solid #ddd;\n  color: #ddd,\n}\n\n.item_dark {\n  color: #dadada;\n  font-size: 14px;\n}\n\n.item_light {\n  color: #1f2023;\n  font-size: 14px;\n}\n\n.warning_area_dark {\n  color: #aaa;\n  background-color: #444;\n}\n\n.warning_area_light {\n  color: gray;\n  background-color: #f5f5f5;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
